import { Box, Heading, Text, VStack } from '@chakra-ui/react'
import ReactMarkdown from 'react-markdown'
import { proseContentCss } from '../../../theme/proseStyles'
import type { NotesBlock, NotesPassage } from '../../../types/reporting'

/**
 * The module's only prose block. No rehype-raw: notes are user-authored free text, so raw HTML
 * must stay unrendered (frontend/src/CLAUDE.md).
 */
function PassageView({ passage }: { passage: NotesPassage }) {
  return (
    <Box
      data-internal={passage.internal ? 'true' : 'false'}
      borderLeftWidth={passage.internal ? '3px' : '0'}
      borderLeftColor="orange.400"
      pl={passage.internal ? 3 : 0}
      mt={2}
    >
      <Text
        fontSize="xs"
        fontWeight="semibold"
        textTransform="uppercase"
        letterSpacing="wide"
        // Not colour alone: print is greyscale, so the marking must survive without hue.
        color={passage.internal ? 'orange.700' : 'gray.500'}
      >
        {passage.internal ? `⚠ ${passage.label}` : passage.label}
      </Text>
      <Box fontSize="sm" css={proseContentCss}>
        <ReactMarkdown>{passage.body}</ReactMarkdown>
      </Box>
    </Box>
  )
}

export function NotesBlockView({ block }: { block: NotesBlock }) {
  return (
    <VStack align="stretch" gap={5} className="report-block">
      {block.entries.map((entry, i) => (
        <Box key={`${entry.heading}-${i}`} className="report-notes-entry">
          <Heading size="sm">{entry.heading}</Heading>
          {!!entry.subheading && (
            <Text fontSize="xs" color="gray.500">{entry.subheading}</Text>
          )}
          {entry.passages.map((p, j) => <PassageView key={`${p.label}-${j}`} passage={p} />)}
        </Box>
      ))}
    </VStack>
  )
}
